export default __webpack_public_path__ + "static/media/a-viewed.8533d324.svg";